const ITEM_COVERAGE_CHART = 'tm_status'

const TOP10_CHART = 'top-compared-items'
const VS_SALES = 'vs-sales'

const ITEM_COVERAGE_STATUSES = [
  {
    name: 'successfully-parsed',
    title: 'Successfully Parsed',
    backgroundColor: '#16C6B9',
    border: 'solid 1px #11988E',
    type: 'is-inverse-primary'
  },
  {
    name: 'vs-optimization-in-progress',
    title: 'VS Optimization in Progress',
    backgroundColor: '#33A3FF',
    border: 'solid 1px #0070CC',
    type: 'is-in-progress'
  },
  {
    name: 'missing-measurements',
    title: 'Missing Measurements',
    backgroundColor: '#F4628E',
    border: 'solid 1px #CC5353',
    type: 'is-inverse-error-1'
  },
  {
    name: 'no-measurements',
    title: 'No Measurements',
    backgroundColor: '#EC386E',
    border: 'solid 1px #BF2E2E',
    type: 'is-inverse-error-2'
  },
  {
    name: 'unsupported-category',
    title: 'Unsupported Category',
    backgroundColor: '#737373',
    border: 'solid 1px #575757',
    type: 'is-inverse-gray'
  }
]

const USAGE_DEFINITION = [
  {
    name: 'clicks',
    rateTitle: 'Click Through Rate',
    valueTitle: 'Clicks',
    rateChartName: 'button-click-through-rate',
    valueChartName: 'button-clicks'
  },
  {
    name: 'comparisons',
    rateTitle: 'Comparison Rate',
    valueTitle: 'Comparison',
    rateChartName: 'comparison-rate',
    valueChartName: 'comparisons'
  },
  {
    name: 'purchased',
    rateTitle: 'Purchase Rate',
    valueTitle: 'Items Purchased',
    rateChartName: 'vs-purchased-share-rate',
    valueChartName: 'vs-purchases'
  },
  {
    name: 'sales',
    rateTitle: 'Sales Rate',
    valueTitle: 'Sales',
    rateChartName: 'vs-sales-share-rate',
    valueChartName: 'vs-sales',
    currency: true
  }
]

const CHART_DEFINITION = [
  {
    name: 'vs-sales',
    title: 'Sales',
    type: 'barChart',
    gridWidth: '6',
    totalFormat: 'currency'
  },
  {
    name: 'unique-user-opened-widget',
    title: 'Virtusize Users',
    type: 'lineChart',
    gridWidth: '6',
    totalFormat: '0,0',
    callAPIWithMonthParam: true
  },
  {
    name: 'comparisons',
    title: 'Comparisons',
    type: 'barChart',
    gridWidth: '6',
    totalFormat: '0,0'
  },
  {
    name: 'unique-user-conversion-rate',
    title: 'User Conversions',
    type: 'lineChart',
    gridWidth: '6',
    totalFormat: '0.0%',
    callAPIWithMonthParam: true
  },
  {
    name: 'top-compared-items',
    title: 'Top 100 Items Compared',
    gridWidth: '6',
    heightClass: 'high-column',
    callAPIWithMonthParam: true
  },
  {
    name: 'coverage-rate',
    title: 'Coverage Rate',
    type: 'lineChart',
    gridWidth: '6',
    totalFormat: '0.0%',
    heightClass: 'high-column',
    logo: 'coverage-rate',
    tooltip: 'Product page views with Virtusize divided by total product page views'
  },
  {
    name: 'item-page-views',
    title: 'Item Page Views',
    totalFormat: '0,0',
    logo: 'page-views'
  },
  {
    name: 'vs-item-page-views',
    totalFormat: '0,0'
  },
  {
    name: 'tm_status',
    title: 'Item Coverage Rate',
    totalFormat: '0.0%'
  }
]

const dashboardChartNames = [
  'vs-sales',
  'unique-user-opened-widget',
  'comparisons',
  'unique-user-conversion-rate',
  'top-compared-items',
  'coverage-rate'
]

const coverageChartNames = [
  'coverage-rate',
  'item-page-views',
  'vs-item-page-views',
  'tm_status'
]

const DASHBOARD_CHART_DEFINITION = CHART_DEFINITION.filter(chart => dashboardChartNames.includes(chart.name))

const COVERAGE_CHART_DEFINITION = CHART_DEFINITION.filter(chart => coverageChartNames.includes(chart.name))

export {
  DASHBOARD_CHART_DEFINITION,
  ITEM_COVERAGE_CHART,
  TOP10_CHART,
  USAGE_DEFINITION,
  COVERAGE_CHART_DEFINITION,
  CHART_DEFINITION,
  ITEM_COVERAGE_STATUSES,
  VS_SALES
}
